import React from "react";

const getPageNumbers = (currentPage, totalPages) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, 4, 5];
  }

  if (currentPage >= totalPages - 2) {
    return [
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ];
  }

  return [
    currentPage - 2,
    currentPage - 1,
    currentPage,
    currentPage + 1,
    currentPage + 2,
  ];
};

const HistoricalPagination = ({
  currentPage,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) => {
  const pageNumbers = getPageNumbers(currentPage, totalPages);

  return (
    <div className="historical-pagination-bar">
      <div className="historical-page-size">
        <select
          id="pageSizeSelect"
          value={pageSize}
          onChange={onPageSizeChange}
          className="historical-page-size-select"
        >
          <option value={10}>show : 10 items per page</option>
          <option value={25}>show : 25 items per page</option>
          <option value={30}>show : 30 items per page</option>
          <option value={50}>show : 50 items per page</option>
        </select>
      </div>

      <div className="react-bootstrap-table-pagination-list">
        <ul className="pagination react-bootstrap-table-page-btns-ul">
          {currentPage > 3 && (
            <PaginationButton
              page={1}
              label="<<"
              title="first page"
              totalPages={totalPages}
              onPageChange={onPageChange}
              className="historical-arrow-link"
            />
          )}

          {currentPage > 1 && (
            <PaginationButton
              page={currentPage - 1}
              label="<"
              title="previous page"
              totalPages={totalPages}
              onPageChange={onPageChange}
              className="historical-arrow-link"
            />
          )}

          {pageNumbers.map((page) => (
            <PaginationButton
              key={page}
              page={page}
              label={page}
              title={String(page)}
              totalPages={totalPages}
              onPageChange={onPageChange}
              active={currentPage === page}
            />
          ))}

          {currentPage < totalPages && (
            <PaginationButton
              page={currentPage + 1}
              label=">"
              title="next page"
              totalPages={totalPages}
              onPageChange={onPageChange}
              className="historical-arrow-link"
            />
          )}

          {currentPage < totalPages && (
            <PaginationButton
              page={totalPages}
              label=">>"
              title="last page"
              totalPages={totalPages}
              onPageChange={onPageChange}
              className="historical-arrow-link"
            />
          )}
        </ul>
      </div>
    </div>
  );
};

const PaginationButton = ({
  page,
  label,
  title,
  totalPages,
  onPageChange,
  active = false,
  className = "",
}) => {
  return (
    <li className={`page-item ${active ? "active" : ""}`} title={title}>
      <button
        type="button"
        className={`page-link ${className}`}
        onClick={() => onPageChange(page, totalPages)}
      >
        {label}
      </button>
    </li>
  );
};

export default HistoricalPagination;